import DayGridScenario from '../schema/DayGridScenario';
import { ClientItemId } from 'owa-client-ids';
import { OwaDate } from 'owa-datetime';
import { DateRange } from 'owa-datetime-utils';
import { action } from 'satcheljs';

export const loadDayGrid = action(
    'loadDayGrid',
    (
        scenario: DayGridScenario,
        initialDate: OwaDate,
        focusTimeDateRange: DateRange,
        folderIds: string[],
        highlightItemId: string
    ) => ({
        scenario,
        initialDate,
        focusTimeDateRange,
        folderIds,
        highlightItemId,
    })
);

export const resetDayGridScenario = action('resetDayGridScenario', (scenario: DayGridScenario) => ({
    scenario,
}));

export const selectDayGridDate = action(
    'selectDayGridDate',
    (scenario: DayGridScenario, newDate: OwaDate) => ({
        scenario,
        newDate,
    })
);

export const clickGridEvent = action(
    'clickGridEvent',
    (scenario: DayGridScenario, id: ClientItemId) => ({
        scenario,
        id,
    })
);

export const doubleClickGridEvent = action(
    'doubleClickGridEvent',
    (scenario: DayGridScenario, id: ClientItemId) => ({
        scenario,
        id,
    })
);

export const rightClickGridEvent = action(
    'rightClickGridEvent',
    (
        scenario: DayGridScenario,
        id: ClientItemId,
        parentFolderId: string,
        event: any,
        getDateRangeToUpdate: () => DateRange
    ) => ({
        scenario,
        id,
        parentFolderId,
        event,
        getDateRangeToUpdate,
    })
);
